import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import CompanySubSelect from "../components/company/CompanySubSelect";
// import '../assets/styles/index.scss';

const queryClient = new QueryClient();

window.addEventListener("message", (e) => {
  if (!e.data.renderCompanySub) return;

  const container = document.getElementById("react-company-sub-select");
  const root = createRoot(container!);
  root.render(
    
      <QueryClientProvider client={queryClient}>
        <CompanySubSelect />
      </QueryClientProvider>
    
  );
});
